import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";

import Examples from "../../Docs/Pipelines/LogViewer/LogViewerExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Log viewer"
            description="The LogViewer component gives a read-only display of a pipelines log file."
            apiSources={["azure-pipelines-ui/Components/LogViewer/LogViewer.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q1-2)"}}
        />
    );
}
}
        
export default Page;